import styles from "./FormField.module.css";
import { FieldError } from "./FieldError";

interface RadioCardGroupProps {
  name: string;
  legend: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
  error?: string;
  required?: boolean;
  helperText?: string;
}

export function RadioCardGroup({
  name,
  legend,
  value,
  onChange,
  options,
  error,
  required,
  helperText,
}: RadioCardGroupProps) {
  const errorId = `${name}-error`;
  const helperId = `${name}-helper`;
  const describedBy =
    [helperText ? helperId : null, error ? errorId : null].filter(Boolean).join(" ") || undefined;

  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.label}>
        {legend} {!required && <span className={styles.optional}>(optioneel)</span>}
      </legend>
      {helperText && (
        <span id={helperId} className={styles.helperText}>
          {helperText}
        </span>
      )}
      <div
        className={styles.radioGroup}
        role="radiogroup"
        aria-describedby={describedBy}
        aria-required={required || undefined}
      >
        {options.map((option) => (
          <label key={option.value} className={styles.radioCard}>
            <input
              type="radio"
              className={styles.radioInput}
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
            />
            {option.label}
          </label>
        ))}
      </div>
      <FieldError id={errorId} message={error} />
    </fieldset>
  );
}
